import { Injectable } from "@angular/core";
import { FormControl } from "@angular/forms";
import { IOpstaPravilaArhivskaDto } from "@kodit/core/data-api";
import { FormBuilderTypeSafe, FormGroupTypeSafe } from "angular-typesafe-reactive-forms-helper";

@Injectable({
  providedIn: 'root',
})

export class OpstaPravilaArhivskaFormService {

  constructor(
    private _fb: FormBuilderTypeSafe
  ) {}

  public GetOpstaPravilaArhivskaFormGroup(
    model?: IOpstaPravilaArhivskaDto
  ): FormGroupTypeSafe<IOpstaPravilaArhivskaDto> {
    return this._fb.group<IOpstaPravilaArhivskaDto>({
      brojSaglasnosti: new FormControl(model?.brojSaglasnosti)
    });
  }
}
